module.exports = __webpack_public_path__ + "belize.svg?fd9b8d379347c8a613412e82cb8a06f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/belize.svg
// module id = 109
// module chunks = 10